import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import patchInsightsReview from "api/insights/patchInsightsReview";
import queryClient from "queryClient";
import { insightsKey } from "queryKeys/insightsKey";
import { tagsListKey } from "queryKeys/tagsList";
import handleInvalidateError from "helpers/handleInvalidateError";

export default function usePatchInsightReview() {
  return useMutation({
    mutationFn: patchInsightsReview,
    onMutate: async (variables) => {
      const { id, status, tags: newTagIds } = variables;

      const tagsListData = queryClient.getQueryData(["tags-list"]);
      const availableTags = tagsListData || [];

      await queryClient.cancelQueries({ queryKey: ["insights-data"] });
      const previousQueries = queryClient.getQueriesData({ queryKey: ["insights-data"] });

      queryClient.setQueriesData({ queryKey: ["insights-data"] }, (old) => {
        if (!old || !old.data) return old;

        return {
          ...old,
          data: old.data.map((item) => {
            if (String(item.documentId) === String(id)) {
              const optimisticTags = newTagIds?.map((tagIdOrName) => {
                if (typeof tagIdOrName === "number") {
                  const found = availableTags.find((t) => t.id === tagIdOrName);
                  return found || { id: tagIdOrName, name: String(tagIdOrName) };
                }
                return { id: tagIdOrName, name: tagIdOrName };
              });

              return {
                ...item,
                reviewStatus: status !== undefined ? status : item.reviewStatus,
                tagsWithColors: optimisticTags !== undefined ? optimisticTags : item.tagsWithColors,
              };
            }
            return item;
          }),
        };
      });

      return { previousQueries };
    },
    onSuccess: ({ message }) => {
      toast.success(message ?? "tag successfully updated!");
      queryClient
        .invalidateQueries({
          queryKey: tagsListKey(),
          exact: false,
        })
        .catch(handleInvalidateError);
    },
    onError: (error, variables, context) => {
      if (context?.previousInsights) {
        queryClient.setQueriesData({ queryKey: insightsKey() }, context.previousInsights);
      }
      toast.error(error.message);
    },
  });
}
